export default __webpack_public_path__ + "static/media/terraform.76fc0c98.svg";